export const Footer = () =>{
    return (
        <div className="footerContainer">
            <p>Daripada Zaid bin Khalid, bahawasanya Rasulullah SAW bersabda:</p>
            <h1 className='arabFont'>مَن فَطَّرَ صَائِمًا كَانَ لَهُ مِثلُ أَجْرِهِ، غَيْرَ أَنَّهُ لَا يَنْقُصُ مِن أَجْرِ الصَّائِمِ شَيئًا</h1>
            <p>Maksudnya: “Siapa yang memberi makan orang yang berpuasa maka baginya pahala seumpamanya tanpa sedikitpun kurang pahala orang berpuasa.”</p>
            <p>(Riwayat Ahmad, al-Tarmizi dan al-Baihaqi)</p>
            <p style={{fontSize:"1vw"}}>Made with ❤️ by <a target="_blank" href='https://fahmijaafar.com'>FJ</a>. © 2024.</p>
        </div>
    )
}